module.exports = __webpack_public_path__ + "img/TRAILER.5d518941.svg";